import React from "react";
import {
  VERDA_CONSTS,
  SHARP_CONSTS,
  NEBRASKA_CONSTS,
  ILS_CONSTS,
} from "../Utils/StaticData/Constant";
import { Text } from "react-internationalization";
const material1 = require("../StaticData/ABRIDGED STANDARD FORMULARY.doc");
const material2 = require("../StaticData/Wipro PDP Summary of Benefits (1).doc.pdf");
const material3 = require("../StaticData/Summary of Benefits - PPO Medicare Advantage - 2021.rtf");
const material4 = require("../StaticData/Enrollment Kit_Combined Files (1).pdf");
const material5 = require("../StaticData/12. 2024 Verda Health Plan Enrollment Form- TX_36450663.pdf");
const material6 = require("../StaticData/13. 2024 Verda Attestation of Eligibility From_36450607.pdf");
const material8 = require("../StaticData/14. Pre-Enrollment Qualification Assessment Form - TX_36451670.pdf");
const material9 = require("../StaticData/15. 2024 Coordination of Care Form - TX_36452218.pdf");
const material10 = require("../StaticData/Benefit Highlights with Cover CSNP.pdf");
const material11 = require("../StaticData/Benefit Highlights with Cover HMO.pdf");
const material12 = require("../StaticData/2025Benefithilight_CSNP.pdf");
const material13 = require("../StaticData/2025Benefithilight_HMO.pdf");
const material14 = require("../StaticData/2025 Attestation of Eligibility From_Question 1.pdf");
const material15 = require("../StaticData/2025 coordination of care.pdf");
const material16 = require("../StaticData/2025 Pre-Enrollment Qual Assessment Form.pdf");
const nebraskaM1 = require("../StaticData/NeBraska/2024-H3170-003-HMO-Sales Kit.pdf");
const nebraskaM2 = require("../StaticData/NeBraska/2024-H8181-001-002-PPO-Sales Kit.pdf");
const nebraskaM3 = require("../StaticData/NeBraska/2024-H3170-003-HMO-SOB.pdf");
const nebraskaM4 = require("../StaticData/NeBraska/2024-H8181-001-002-PPO-SOB.pdf");
const ilsM1 = require("../StaticData/Ils/2024 FC2 Summary Of Benefits for PBP 001 and 002_English.pdf");
const ilsM2 = require("../StaticData/Ils/2024 FC2_FLEXCatalog_ _002_003_English.pdf");
const ilsM3 = require("../StaticData/Ils/2024 FC2_OTCHS_Catalog_ ALL plans _001_002_003_English.pdf");
const ilsM4 = require("../StaticData/Ils/2024 FC2_Summary Of Benefits for PBP 003_English.pdf");
const ilsM5 = require("../StaticData/Ils/FC2_2024_Comprehensive-Formulary_All Plans_001_002_003_E AND S.pdf");
const ilsM6 = require("../StaticData/Ils/FC2_Star_Rating_2024_ALl plans_001_002_003_English.pdf");
const ilsM7 = require("../StaticData/Ils/H9986_2025 Sales Presentation V2_10_8_24.pdf");

const verdaMaterial = [
  {
    txt: <Text id="app.verdam1" />,
    material: material4,
    year: "2024",
  },
  {
    txt: <Text id="app.verdam2" />,
    material: material10,
    year: "2024",
  },
  {
    txt: <Text id="app.verdam3" />,
    material: material11,
    year: "2024",
  },
  {
    txt: <Text id="app.verdam4" />,
    material: material5,
    year: "2024",
  },
  {
    txt: <Text id="app.verdam5" />,
    material: material6,
    year: "2024",
  },
  {
    txt: <Text id="app.verdam6" />,
    material: material8,
    year: "2024",
  },
  {
    txt: <Text id="app.verdam7" />,
    material: material9,
    year: "2024",
  },
  {
    txt: <Text id="app.verdam8" />,
    material: material12,
    year: "2025",
  },
  {
    txt: <Text id="app.verdam9" />,
    material: material13,
    year: "2025",
  },
  {
    txt: <Text id="app.verdam10" />,
    material: material14,
    year: "2025",
  },
  {
    txt: <Text id="app.verdam11" />,
    material: material15,
    year: "2025",
  },
  {
    txt: <Text id="app.verdam12" />,
    material: material16,
    year: "2025",
  },
];
const nebraskaMaterial = [
  {
    txt: <Text id="app.nebraskam1" />,
    material: nebraskaM1,
  },
  {
    txt: <Text id="app.nebraskam2" />,
    material: nebraskaM2,
  },
  {
    txt: <Text id="app.nebraskam3" />,
    material: nebraskaM3,
  },
  {
    txt: <Text id="app.nebraskam4" />,
    material: nebraskaM4,
  },
];

const ilsMaterial = [
  // {
  //   txt: <Text id="app.ils7" />,
  //   material: ilsM7,
  //   year: "2025",
  // },
  {
    txt: <Text id="app.ils1" />,
    material: ilsM1,
  },
  {
    txt: <Text id="app.ils2" />,
    material: ilsM2,
  },
  {
    txt: <Text id="app.ils3" />,
    material: ilsM3,
  },
  {
    txt: <Text id="app.ils4" />,
    material: ilsM4,
  },
  {
    txt: <Text id="app.ils5" />,
    material: ilsM5,
  },
  {
    txt: <Text id="app.ils6" />,
    material: ilsM6,
  },
];
const SalesMaterial = (customerId) => {
  const year = window.sessionStorage.getItem("year");
  // const materials = ()=>{
  let salesmaterial;
  switch (customerId) {
    case SHARP_CONSTS.VANILLA_DEMO_CUSTOMER_ID:
    case SHARP_CONSTS.VANILLA_CUSTOMER_ID: {
      salesmaterial = (
        <React.Fragment>
          <div class="head-slide sidebar-fontcolor">
            <Text id="app.salesm" />
          </div>
          <div class="materials">
            <div class="compare-plans">
              <a
                class="sidebar-fontcolor2"
                href={material1}
                download="ABRIDGED STANDARD FORMULARY.doc"
              >
                <Text id="app.asf" />
              </a>
            </div>
            <div class="compare-plans">
              <a class="sidebar-fontcolor2" href={material2} download>
                <Text id="app.wpdpsob" />
              </a>
            </div>
            <div class="compare-plans sales-margin">
              <a
                class="sidebar-fontcolor2"
                href={material3}
                download="Summary of Benefits - PPO Medicare Advantage - 2021.rtf"
              >
                <Text id="app.sob" />
              </a>
            </div>
          </div>
        </React.Fragment>
      );
      break;
    }
    case VERDA_CONSTS.ID: {
      salesmaterial = (
        <React.Fragment>
          <div class="head-slide sidebar-fontcolor">
            <Text id="app.salesm" />
          </div>
          <div class="materials">
            {verdaMaterial.map(
              (m, i) =>
                m.year === year && (
                  <div class="compare-plans" key={i}>
                    <a
                      class="sidebar-fontcolor2"
                      href={m.material}
                      // download={`${m["txt"]}`}
                      download
                    >
                      {m.txt}
                    </a>
                  </div>
                )
            )}
          </div>
        </React.Fragment>
      );
      break;
    }
    case NEBRASKA_CONSTS.ID: {
      salesmaterial = (
        <React.Fragment>
          <div class="head-slide sidebar-fontcolor">
            <Text id="app.salesm" />
          </div>
          <div class="materials">
            {nebraskaMaterial.map((m, i) => (
              <div class="compare-plans" key={i}>
                <a
                  class="sidebar-fontcolor2"
                  href={m.material}
                  // download={`${m["txt"]}`}
                  download
                >
                  {m.txt}
                </a>
              </div>
            ))}
          </div>
        </React.Fragment>
      );
      break;
    }
    case ILS_CONSTS.ID: {
      salesmaterial = (
        <React.Fragment>
          <div class="head-slide sidebar-fontcolor">
            <Text id="app.salesm" />
          </div>
          <div class="materials">
          {year === "2025" && (
              <div class="compare-plans">
                <a
                  class="sidebar-fontcolor2"
                  href={ilsM7}
                  // download={`${m["txt"]}`}
                  download
                >
                  <Text id="app.ils7" />
                </a>
              </div>
            )}
            {ilsMaterial.map((m, i) => (
              <div class="compare-plans" key={i}>
                <a
                  class="sidebar-fontcolor2"
                  href={m.material}
                  // download={`${m["txt"]}`}
                  download
                >
                  {m.txt}
                </a>
              </div>
            ))}
        
          </div>
        </React.Fragment>
      );
      break;
    }
  }
  // };
  return salesmaterial;
  // let material = materials[customerId];
  // if (material === undefined) {
  //   material = null;
  // }
  // return material;
  // materials()
};
export default SalesMaterial;
